import React, { useEffect, useRef, useState } from "react";

// Serves the approved static marketing page (public/landing-v6.html) at the root
// for logged-out visitors. Content is injected into the DOM (not an iframe) so it
// stays crawlable. The file is the single source of truth — to update the landing,
// replace public/landing-v6.html.
export default function Landing() {
  const containerRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const injected = [];
    const prevTitle = document.title;

    (async () => {
      try {
        const res = await fetch("/landing-v6.html", { cache: "no-cache" });
        if (!res.ok) throw new Error("fetch failed");
        const html = await res.text();
        if (cancelled) return;
        const doc = new DOMParser().parseFromString(html, "text/html");

        // <head>: fonts + page styles
        doc.head.querySelectorAll('link[rel="preconnect"], link[rel="stylesheet"], style').forEach((node) => {
          const clone = node.cloneNode(true);
          clone.setAttribute("data-landing", "");
          document.head.appendChild(clone);
          injected.push(clone);
        });

        // SEO: reflect the landing's title/description at /
        const t = doc.querySelector("title");
        if (t) document.title = t.textContent;

        // <body> markup
        if (containerRef.current) {
          containerRef.current.innerHTML = doc.body.innerHTML;
          // re-create scripts so they execute (innerHTML scripts don't run)
          doc.body.querySelectorAll("script").forEach((old) => {
            const s = document.createElement("script");
            if (old.src) s.src = old.src;
            else s.textContent = old.textContent;
            containerRef.current.appendChild(s);
          });
        }
      } catch (e) {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      injected.forEach((n) => n.remove());
      document.head.querySelectorAll("[data-landing]").forEach((n) => n.remove());
      document.title = prevTitle;
    };
  }, []);

  if (failed) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, fontFamily: "system-ui" }}>
        <h1>SiteProApp</h1>
        <p>Site compliance software for Australian builders.</p>
        <div style={{ display: "flex", gap: 12 }}>
          <a href="/login" style={{ padding: "10px 18px", background: "#0D1B2A", color: "#fff", borderRadius: 8, textDecoration: "none" }}>Log in</a>
          <a href="/pricing" style={{ padding: "10px 18px", border: "1px solid #0D1B2A", borderRadius: 8, textDecoration: "none", color: "#0D1B2A" }}>Start free trial</a>
        </div>
      </div>
    );
  }

  return <div ref={containerRef} data-testid="landing-root" />;
}
